import { combineReducers } from 'redux'
import * as actions from '../actions'
import i18n from '../i18n'
import * as constants from '../services/Constants'

const RETURNS = 'returns'
const ASC = 'ASC'
const DESC = 'DESC'

const shouldShowTimePeriod = (list, timePeriod) => list.some((pd) => pd.timePeriod === timePeriod && pd.entities.length > 0)

const performers = (state = {}, action) => {
  switch (action.type) {
    case actions.LOAD_PERFORMERS:
      let allfilterCat = action.payload.typeCats.filter((obj) => obj)
      let parents = []
      let newItem = ''
      let tier1CatOptions = []
      let tier2CatOptions = []

      for (let i = 0; i < allfilterCat.length; i++) {
        newItem = allfilterCat[i].substring(0, allfilterCat[i].indexOf('-'))
        if (parents.indexOf(newItem) === -1) {
          parents.push(newItem.trim())
        }
      }
      for (let ii = 0; ii < allfilterCat.length; ii++) {
        let [t1, t2] = allfilterCat[ii].split('-')
        if (t1) {
          if (tier1CatOptions.indexOf(t1.trim()) === -1) {
            tier1CatOptions.push(t1.trim())
          }
        }
        if (t2) {
          if (tier2CatOptions.indexOf(t2.trim()) === -1) {
            tier2CatOptions.push(t2.trim())
          }
        }
      }
      const filtered = allfilterCat
        .filter(function (item) {
          return tier1CatOptions.indexOf(item) === -1
        })
        .sort()

      const currencyOptions = [constants.CUR_USD, constants.CUR_GBP, constants.CUR_EUR].sort()
      const list = action.payload.topPerformers

      //console.log ('data:', action.payload.topPerformers)
      allfilterCat = allfilterCat.concat(parents)
      tier1CatOptions = tier1CatOptions.filter(Boolean).sort()
      return Object.assign({}, state, {
        data: action.payload.topPerformers,
        initialLoad: true,
        typeCats: allfilterCat,
        tier1CatOptions: tier1CatOptions,
        tier2CatOptions: filtered,
        currencyOptions: currencyOptions,
        timePeriod01_button: shouldShowTimePeriod(list, constants.YR_01_ROR_NAV),
        timePeriod03_button: shouldShowTimePeriod(list, constants.YR_03_ROR_NAV),
        timePeriod05_button: shouldShowTimePeriod(list, constants.YR_05_ROR_NAV),
        timePeriod10_button: shouldShowTimePeriod(list, constants.YR_10_ROR_NAV)
      })

    case actions.SET_PERIOD:
      return Object.assign({}, state, {
        period: action.payload
      })

    case actions.SET_TYPE:
      return Object.assign({}, state, {
        type: action.payload
      })

    case actions.SET_TOPN:
      return Object.assign({}, state, {
        topn: action.payload
      })

    case actions.SET_FUNDCCY:
      return Object.assign({}, state, {
        selectedCurrencyOption: action.payload
      })

    case actions.SET_CURRENCY:
      const currencyFilter = action.payload
      return Object.assign({}, state, {
        selectedCurrencyOption: currencyFilter
      })

    case actions.RESET_LOAD_STATUS:
      const reloadStatus = action.value
      return Object.assign({}, state, {
        initialLoad: reloadStatus
      })

    case actions.SET_TIER1CAT:
      const tier1Filter = action.payload
      const typeCat1 = tier1Filter
      const multiTypeCat1 = typeCat1.map((cat) => `${cat}`).join('|')
      return Object.assign({}, state, {
        selectedTier1Options: tier1Filter,
        // selectedTier1CatOptions: tier1Filter,
        selectedTier2Options: '',
        typeCat: multiTypeCat1
      })

    case actions.SET_TIER2CAT:
      const tier2Filter = action.payload
      const typeCat2 = tier2Filter
      const multiTypeCat2 = typeCat2.map((cat) => `${cat}`).join('|')
      return Object.assign({}, state, {
        selectedTier2Options: tier2Filter,
        // selectedTier2CatOptions: tier2Filter,
        selectedTier1Options: '',
        typeCat: multiTypeCat2
      })

    case actions.SET_COBDATE:
      return Object.assign({}, state, {
        cobdate: action.payload
      })

    case actions.GET_ENTITIES:
      const performance = state.data.filter(function (value) {
        return value.timePeriod === state.period + state.type
      })
      return Object.assign({}, state, {
        entities: performance.length > 0 ? performance[0].entities : []
      })

    case actions.SET_SORT:
      let column = action.column
      let direction = state.sortDirection
      if (column === '') {
        column = RETURNS
        direction = state.topn > 0 ? DESC : ASC
      } else if (column === state.sortColumn) {
        direction = state.sortDirection === ASC ? DESC : ASC
      } else {
        direction = ASC
      }
      return Object.assign({}, state, {
        sortColumn: column,
        sortDirection: direction
      })

    case actions.SORT_DATA:
      let sortedData = state.entities
      if (state.sortColumn !== RETURNS) {
        sortedData = state.entities.sort((a, b) => a[state.sortColumn].localeCompare(b[state.sortColumn]))
      } else {
        sortedData = state.entities.sort((a, b) => a[state.period + state.type] - b[state.period + state.type])
      }
      if (state.sortDirection === DESC) {
        sortedData.reverse()
      }
      return Object.assign({}, state, {
        entities: sortedData
      })

    case actions.SET_LEV_TYPE:
      console.log('reducer-levtype', action.payload)
      let isSL = action.payload === i18n.t('ShortAndLeveraged') ? 'true' : 'false'
      return Object.assign({}, state, {
        levType: action.payload,
        isSL: isSL
      })

    default:
      return state
  }
}

export const getSelectedTier1CatOption = (state) => state.performers.selectedTier1Options
export const getSelectedTier2CatOption = (state) => state.performers.selectedTier2Options
export const getSelectedCurrencyOption = (state) => state.performers.selectedCurrencyOption
export const getAsOfDate = (state) => state.data.asOfDate
export const getInitialLoad = (state) => state.performers.initialLoad

export const getCurrencyOption = (state) => {
  //console.log('red', state.performers.currencyOptions)
  if (state.performers.currencyOptions) {
    return [...new Set(state.performers.currencyOptions)]
  }
  return [...new Set([''])]
}

export const getTier1CatOption = (state) => {
  if (state.performers.tier1CatOptions) {
    return [...new Set(state.performers.tier1CatOptions)]
  }
  return [...new Set([''])]
}

export const getTier2CatOption = (state) => {
  if (state.performers.tier2CatOptions) {
    return [...new Set(state.performers.tier2CatOptions)]
  }
  return [...new Set([''])]
}
const rootReducer = combineReducers({
  performers
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js